import { Component, OnInit, OnDestroy } from '@angular/core';
import { GenericSliderService } from '@shared/service/genericSlider.service';
import { takeUntil } from 'rxjs/operators';
import { Subscription, Subject } from 'rxjs';
import { CommonService } from '@shared/service/common.service';
import { utiles } from '@utl/environment';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ModalPrivacyPoliticiesComponent } from '@shared/modal/modal-privacy-policies/modal-privacy-policies.component';
import { GenericSlidersModel } from '@core/model/genericSliders.model';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();
  private subscriptions: Subscription[] = [];
  socialMediaList: any;
  socialNetName: string = 'LTSocialNet';
  public curYear = new Date().getFullYear();

  constructor(
    private genericSliderService: GenericSliderService,
    private common: CommonService,
    private router: Router,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    let data = utiles.getCacheUser();
    if (data !== null && data !== undefined) {
      this.getSocialNetworks();
    } else {
      this.router.navigate(['login']);
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getSocialNetworks() {
    let model = new GenericSlidersModel();
    model.SliderId = this.socialNetName;
    this.genericSliderService.getSocialNetworks(model)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        response => {
          this.socialMediaList = response;
        },
      );
  }

  openModalPrivacyPoliticies() {
    const dialogRef = this.dialog.open(ModalPrivacyPoliticiesComponent, {
      data: {
        status: false
      },
      minWidth: '35vw', maxWidth: '35vw', maxHeight: '95vh', minHeight: '65vh'
    });
    dialogRef.beforeClosed().pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {
    });
  }

  goToBranchOffices() {
    this.router.navigate(['branchoffices']);
  }

  goToContactUs() {
    this.router.navigate(['contactus']);
  }
}
